import { AppRouteProps } from '@harea/component'
import React from 'react'

const Dashboard = React.lazy(() => import('./Dahboard'))

export const HomeRoutes: Array<AppRouteProps> = [
    { 
        path: '', 
        element: <Dashboard />,
    }
]
